export const initTabsWithDescription = () => {
	const tabsSections = document.querySelectorAll( 'section.tabs-with-description' );

	if ( !tabsSections.length )
	{
		return;
	}

	const calculateSliderHeight = ( slider ) => {
		if ( window.innerWidth > 635 )
		{
			slider.querySelector( 'ul.slides' ).removeAttribute( 'style' );
			return;
		}
		
		const paragraphs = slider.querySelectorAll( 'ul.slides p' );
		let maxHeight = 0;

		Array.from( paragraphs ).forEach( ( it ) => {
			if ( it.offsetHeight > maxHeight )
			{
				maxHeight = it.offsetHeight;
			}
		} );

		maxHeight += 40;
		slider.querySelector( 'ul.slides' ).style.height = maxHeight + 'px';
	};

	Array.from( tabsSections ).forEach( ( it ) => {
		calculateSliderHeight( it );

		window.addEventListener( 'resize', () => {
			calculateSliderHeight( it );
		} );
	} );
};